import { render, staticRenderFns } from "./companyCustomInfo.vue?vue&type=template&id=1d597e1f"
import script from "./companyCustomInfo.vue?vue&type=script&lang=js"
export * from "./companyCustomInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports